import { useCallback, useEffect } from 'react';

import { useIsInView } from '@lumapps/utils/hooks/useIsInView';

import { ITEM_IMPRESSION_THRESHOLD } from '../constants';
import { lumappsAnalyticsPlugin } from '../tracking';
import { TargetType, TrackingEventType } from '../types';

/**
 * This hook is tracking impressions.
 * When the tracked item (ref attached) enter the viewport, it will trigger a batched tracking event
 * @param targetId string
 * @param targetType TargetType
 * @returns ref to attach to the tracked element
 */
export const useImpressionTracking = (targetId: string, targetType: TargetType) => {
    const registerImpression = useCallback(() => {
        lumappsAnalyticsPlugin.trackAndBatch({
            payload: { action: { targetId, targetType, type: TrackingEventType.VIEW } },
        });
    }, [targetId, targetType]);

    const { ref, inView } = useIsInView({
        threshold: ITEM_IMPRESSION_THRESHOLD,
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) {
            registerImpression();
        }
    }, [inView, registerImpression]);

    return ref;
};
